// Single source of truth for all design tokens and colour maps used
// across every TodoTask component (board, list, calendar).

export const T = {
  primary:     "#0D9488",
  primaryDark: "#0F766E",
  primaryLight:"#F0FDFA",
  primaryGlow: "rgba(13,148,136,0.15)",
  accent:      "#6366F1",
  bg:          "#F1F5F9",
  surface:     "#FFFFFF",
  border:      "#E2E8F0",
  borderLight: "#F1F5F9",
  text:        "#0F172A",
  textSub:     "#475569",
  textMuted:   "#94A3B8",
  shadow: {
    xs:      "0 1px 2px rgba(15,23,42,0.05)",
    sm:      "0 1px 4px rgba(15,23,42,0.07), 0 1px 2px rgba(15,23,42,0.04)",
    md:      "0 4px 16px rgba(15,23,42,0.08), 0 1px 4px rgba(15,23,42,0.04)",
    lg:      "0 12px 32px rgba(15,23,42,0.10), 0 4px 12px rgba(15,23,42,0.05)",
    primary: "0 4px 18px rgba(13,148,136,0.30)",
  },
};

// ─── Priority colour maps (key = priority number: 1=Low, 2=Medium, 3=High) ───
export const PRI_BG    = { 3: "#FEF2F2", 2: "#FFFBEB", 1: "#ECFDF5" };
export const PRI_TEXT  = { 3: "#DC2626", 2: "#D97706", 1: "#059669" };
export const PRI_DOT   = { 3: "#EF4444", 2: "#F59E0B", 1: "#22C55E" };
export const PRI_LABEL = { 1: "Low",    2: "Medium",   3: "High"    };

// Combined bg+color shape — used by board/list table chips
export const PRI_COLOR = {
  3: { bg: "#FEF2F2", color: "#DC2626" },
  2: { bg: "#FFFBEB", color: "#D97706" },
  1: { bg: "#ECFDF5", color: "#059669" },
};

// ─── Status colour maps (key = status number) ─────────────────────────────────
export const STATUS_LABEL = {
  1: "To Do",        2: "In Progress",   3: "Completed",
  4: "Not Assigned", 5: "Acknowledge",   6: "Rework Required",
  7: "Hold",         8: "Duplicate",
};
export const STATUS_BG   = {
  1: "#F1F5F9", 2: "#CCFBF1", 3: "#DCFCE7",
  4: "#F0FDFA", 5: "#CFFAFE", 6: "#FEE2E2",
  7: "#FFF7ED", 8: "#F8FAFC",
};
export const STATUS_TEXT = {
  1: "#475569", 2: "#0F766E", 3: "#15803D",
  4: "#0F766E", 5: "#0E7490", 6: "#B91C1C",
  7: "#C2410C", 8: "#64748B",
};

// Combined bg+color shape — used by board/list table chips
export const STATUS_COLOR = {
  1: { bg: "#F1F5F9", color: "#475569" },
  2: { bg: "#CCFBF1", color: "#0F766E" },
  3: { bg: "#DCFCE7", color: "#15803D" },
  4: { bg: "#F0FDFA", color: "#0F766E" },
  5: { bg: "#CFFAFE", color: "#0E7490" },
  6: { bg: "#FEE2E2", color: "#B91C1C" },
  7: { bg: "#FFF7ED", color: "#C2410C" },
  8: { bg: "#F8FAFC", color: "#64748B" },
};

// ─── Calendar-specific constants ──────────────────────────────────────────────
export const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MAX_PILLS = 3;
